import { render, staticRenderFns } from "./ScoreNum.vue?vue&type=template&id=fc967638&scoped=true&"
import script from "./ScoreNum.vue?vue&type=script&lang=js&"
export * from "./ScoreNum.vue?vue&type=script&lang=js&"
import style0 from "./ScoreNum.vue?vue&type=style&index=0&id=fc967638&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc967638",
  null
  
)

export default component.exports